import { getTotalRetirement, getTotalRetirementByDeath, getByRfc, getByStatus,
          save, cancel, accept, reject, getAll } from '@/api/retirement'


export default class Retirement {
  static typeRetirement = {
    "pension": "Pensión",
    "jubilacion": "Jubilación",
    "retiro_voluntario": "Voluntario",
    "defuncion": "Defunción"
  }

  constructor() {

  }

  save = ({token_auth, rfc, email, cellphone, date_of_admission, 
    interbank_clabe, bank_name, amount, beneficiary_name, beneficiary_middle_name, 
    beneficiary_maternal_name, beneficiary_paternal_name,
    amount_without_interest, interest, 
    percentage, type_of_retirement, document_list}) => {
    return save({token_auth, rfc, email, cellphone, date_of_admission, 
      interbank_clabe, bank_name, amount, beneficiary_name, beneficiary_middle_name, 
      beneficiary_maternal_name, beneficiary_paternal_name,
      amount_without_interest, interest, 
      percentage, type_of_retirement, document_list}).then(response => {
      return response;
    }).catch(error => {
      throw error.response.data.errors;
    })
  }

  cancel = (tokenAuth, id) => {
    return cancel(tokenAuth, id).then(response => {
      return response;
    }).catch(error => {
      throw error.response.data.errors;
    })
  }

  accept = (tokenAuth, id) => {
    return accept(tokenAuth, id).then(response => {
      return response;
    }).catch(error => {
      throw error.response.data.errors;
    })
  }

  reject = (tokenAuth, id) => {
    return reject(tokenAuth, id).then(response => {
      return response;
    }).catch(error => {
      throw error.response.data.errors;
    })
  }

  getByRfc = (tokenAuth, rfc) => {
    return getByRfc(tokenAuth, rfc).then(response => {
      return response;
    }).catch(error => {
      throw error.response.data.errors;
    })
  }

  getByStatus = (tokenAuth, status) => {
    return getByStatus(tokenAuth, status).then(response => {
      return response;
    }).catch(error => {
      throw error.response.data.errors;
    })
  }

  getTotalRetirement = (tokenAuth, rfc, admissionDate) => {
    return getTotalRetirement(tokenAuth, rfc, admissionDate).then(response => {
      return response;
    }).catch(error => {
      throw error.response.data.errors;
    })
  }

  getTotalRetirementByDeath = (tokenAuth, rfc, admissionDate) => {
    return getTotalRetirementByDeath(tokenAuth, rfc, admissionDate).then(response => {
      return response;
    }).catch(error => {
      throw error.response.data.errors;
    })
  }

  getAll = (tokenAuth, process_name) => {
    return getAll(tokenAuth, process_name).then(response => {
      return response;
    }).catch(error => {
      throw error.response.data.errors;
    })
  }
}